import { getEnvValue } from '../Helper/env';

const apiUrlEnv = getEnvValue('RAZZLE_API_URL', { nativeKey: 'API_URL' });
const webAppURL =
  getEnvValue('RAZZLE_APP_URL') || 'https://marketplace.stg.pickup.ph';
const apiURL = apiUrlEnv || 'https://marketplace-api.stg.pickup.ph';
const paymentUrl = getEnvValue('RAZZLE_CHECKOUT_PAYMENT_URL', {
  nativeKey: 'CHECKOUT_PAYMENT_URL',
});
const sentryEnv = apiUrlEnv ? 'production' : 'staging';

const API = {
  STOPLIGHT: 'https://stoplight.io/mocks/pickup/customer-app-api/399135',
  BUCKET: 'https://pickup-marketplace.s3.ap-southeast-1.amazonaws.com',
};

export default {
  BUCKET: API.BUCKET,
  PAYMENT: paymentUrl || 'https://payments.stg.pickup.ph',
  ROOT_API: apiURL,
  SENTRY_ENV: sentryEnv,
  STATIC_API: API.STOPLIGHT,
  WEB: webAppURL,
};
